import { markdownNode } from './utils/markdown-node';

export const propTypes = {
    post: markdownNode
};
